import { render } from "./MessageButton.vue?vue&type=template&id=38b4dca6"
import script from "./MessageButton.vue?vue&type=script&lang=js"
export * from "./MessageButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__